export interface RecentBuyer {
  name: string
  country: string
  minutesAgo: number
}

export const recentBuyers: RecentBuyer[] = [
  { name: 'Dra. Valentina Rojas', country: 'Chile', minutesAgo: 2 },
  { name: 'Dr. Andrés Beltrán', country: 'Colombia', minutesAgo: 4 },
  { name: 'Dra. Lucía Fernández', country: 'Argentina', minutesAgo: 6 },
  { name: 'Dr. Javier Morales', country: 'México', minutesAgo: 3 },
  { name: 'Dra. Camila Herrera', country: 'Perú', minutesAgo: 8 },
  { name: 'Dr. Sebastián Ortiz', country: 'Ecuador', minutesAgo: 5 },
  { name: 'Dra. Paula Giménez', country: 'Uruguay', minutesAgo: 7 },
  { name: 'Dr. Ricardo Salazar', country: 'España', minutesAgo: 9 },
  { name: 'Dra. Mariana Castro', country: 'Costa Rica', minutesAgo: 2 },
  { name: 'Dr. Emilio Vargas', country: 'Guatemala', minutesAgo: 11 },
  { name: 'Dra. Sofía Delgado', country: 'Panamá', minutesAgo: 4 },
  { name: 'Dr. Tomás Aguirre', country: 'Bolivia', minutesAgo: 6 },
  { name: 'Dra. Isabel Núñez', country: 'República Dominicana', minutesAgo: 10 },
  { name: 'Dr. Martín Peña', country: 'Paraguay', minutesAgo: 3 },
  { name: 'Dra. Gabriela Ruiz', country: 'Venezuela', minutesAgo: 7 },
]
